<template>
  <div class="flex h-screen bg-gray-100">
    <!-- Sidebar Navigation -->
    <Sidebar />
    
    <!-- Conversation List -->
    <div class="w-96 bg-white border-r border-gray-200 flex flex-col">
      <ConversationList />
    </div>
    
    <!-- Chat Area + Lead Details -->
    <div class="flex-1 flex">
      <ChatWindow class="flex-1" />
      <LeadDetailsPanel 
        v-if="activeConversation"
        class="w-80 bg-white border-l border-gray-200" 
      />
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import Sidebar from '@/components/layout/Sidebar.vue'
import ConversationList from '@/components/inbox/ConversationList.vue'
import ChatWindow from '@/components/chat/ChatWindow.vue'
import LeadDetailsPanel from '@/components/chat/LeadDetailsPanel.vue'
import { useConversationsStore } from '@/stores/conversations'

const route = useRoute()
const conversationsStore = useConversationsStore()

const activeConversation = computed(() => conversationsStore.activeConversation)

onMounted(async () => {
  // Fetch initial conversations
  await conversationsStore.fetchConversations()
  
  // Se há query param 'conversation', selecionar automaticamente
  if (route.query.conversation) {
    const conversationId = parseInt(route.query.conversation)
    conversationsStore.setActiveConversation(conversationId)
  }
  
  // Start polling for updates
  conversationsStore.startPolling()
})

// Watch para mudanças no query param
watch(() => route.query.conversation, (newId) => {
  if (newId) {
    conversationsStore.setActiveConversation(parseInt(newId))
  }
})

onUnmounted(() => {
  // Stop polling when leaving view
  conversationsStore.stopPolling()
})
</script>
